import React, { type FC } from 'react';

import type { LoadableType } from '@confluence/loadable';
import { LoadableAfterPaint, useSSRPlaceholderReplaceIdProp } from '@confluence/loadable';
import type { ContextualCreatePopoverProps } from '../CreateContentPopover/ContextualCreateContentPopover/ContextualCreateContentPopover.tsx';

export const ContextualCreateContentPopoverLoader: LoadableType<ContextualCreatePopoverProps> =
	LoadableAfterPaint({
		loader: async () =>
			(
				await import(
					/* webpackChunkName: "loadable-ContextualCreatePopover" */ '../CreateContentPopover/index.ts'
				)
			).ContextualCreateContentPopover,
	});

type TreeBottomCreateButtonProps = {
	spaceKey: string;
	source: string;
};

export const TreeBottomCreateButton: FC<TreeBottomCreateButtonProps> = ({ spaceKey, source }) => {
	const ssrPlaceholderIdProp = useSSRPlaceholderReplaceIdProp();

	return (
		<div
			data-testid="page-tree-create-button"
			data-vc="page-tree-create-button"
			{...ssrPlaceholderIdProp}
		>
			<ContextualCreateContentPopoverLoader
				spaceKey={spaceKey}
				source={source}
				isTreeItem
				shouldRenderToParent
			/>
		</div>
	);
};
